// userSettings lib
import generateUserSettingsStore from '../../userSettings/lib/generateUserSettingsStore.lib.userSettings';

export default generateUserSettingsStore({
  domain: 'notification',
  defaultSettings: {notifications: []},
});
